import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { PresetsRevisionsList, PresetsRevisionsListV } from "@/types/revisions";
import { toUnion } from "fp-ts/Either";
import { mapLeft } from "fp-ts/lib/Either";

export async function fetchRemotePresetsRevisions(): Promise<PresetsRevisionsList | null> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_retrieve_presets_revisions",
      decoder: PresetsRevisionsListV
    }),
    // makeWordPressAjaxRequest does all the error logging already, there's no point to call logErrorsToUiStore()
    mapLeft(() => null),
    toUnion
  );
}
